import { ChartData } from 'chart.js';
import { ChartComponentProps } from 'react-chartjs-2';

interface CommonChartProps {
    data: ChartData;
    chartProps?: ChartComponentProps;
}

export type GeneralChartComponentProps = DougnutComponentProps | LineComponentProps ;

export interface DougnutComponentProps extends CommonChartProps {
    type: ChartTypes.DOUGHNUT;
}

export interface LineComponentProps extends CommonChartProps {
    type: ChartTypes.LINE;
}

export enum ChartTypes {
    LINE,
    DOUGHNUT,
}
